<template>
  <div>
    <Card overflow="y">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <img v-if="titleImage" class="mb-4 h-16 w-auto m-auto" :src="titleImage" />
          <div class="flex">
            <h3 class="text-lg font-medium leading-6 text-gray-900 mr-2">{{ title }}</h3>
            <slot name="title-icon"></slot>
          </div>
          <p class="mt-1 text-sm text-gray-500">
            {{ description }}
          </p>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
          <form class="space-y-6">
            <slot></slot>
          </form>
        </div>
      </div>
      <slot name="footer"></slot>
    </Card>
    <div class="mt-4 flex justify-end">
      <TButton
        v-if="!hidecancel"
        class="mr-2"
        :label="cancel ? cancel : 'Cancel'"
        color="white"
        @click="handleCancel"
      />
      <TButton
        v-if="showSecondaryAction"
        class="mr-2"
        :label="secondaryAction"
        color="white"
        @click="handleSecondaryAction"
      />
      <TButton 
        v-if="!hideaction" 
        :label="action" 
        :color="actioncolor ? actioncolor : 'indigo'" 
        :disabled="actionDisabled"
        @click="handleAction"
      >
        <LocalLoadingSpinner />
      </TButton>
    </div>
  </div>
</template>

<script>
import Card from '../Card/index.vue';
import LocalLoadingSpinner from './LocalLoadingSpinner.vue';

export default {
  props: {
    title: String,
    description: String,
    cancel: String,
    action: String,
    hidecancel: Boolean,
    hideaction: Boolean,
    titleImage: String,
    actioncolor: String,
    showSecondaryAction: Boolean,
    secondaryAction: String,
    actionDisabled: {
      type: Boolean,
      default: false
    },
  },
  components: {
    Card,
    LocalLoadingSpinner,
  },
  methods: {
    handleCancel() {
      this.$emit('handleCancel');
    },
    handleAction() {
      this.$emit('handleAction');
    },
    handleSecondaryAction() {
      this.$emit('handleSecondaryAction');
    },
  },
};
</script>
